import { useSnapshot } from "valtio";
import { ActionsFromStores, StoreFromStores, stores, Stores } from "./stores";

// This type is to recursively remove the readonly nastyness that Valtio adds
export type GlobalState<TStore> = {
  -readonly [Key in keyof TStore]: TStore[Key] extends object
    ? TStore[Key] extends () => unknown
      ? TStore[Key]
      : GlobalState<TStore[Key]>
    : TStore[Key];
};

/**
 * useGlobalState - this is a basic hook to cast the store correctly.
 * It has been designed to work like useState [accessor & updater]
 * @param store
 * @returns
 */
export function useGlobalState<T extends Stores>(
  store: T
): [GlobalState<StoreFromStores<T>>, ActionsFromStores<T>] {
  const state = stores[store];

  const snap = useSnapshot(state.state) as GlobalState<StoreFromStores<T>>;
  return [snap, state.actions];
}
